// Shared area dictionary — common components (components/common/*), the MAKEJ!
// agent widget (components/agent/*), LoginPage, authStore and the API client.
export const shared = {
  login: {
    administration: "Administration",
    signInTitle: "Sign In",
    signInButton: "Sign In",
    signingIn: "Signing in…",
    password: "Password",
    emailPlaceholder: "your@email.com",
    copyright: "© {{year}} CK Go2. All rights reserved.",
  },
  auth: {
    loginFailed: "Login failed",
  },
  apiClient: {
    uploadFailed: "Upload failed",
    loadFileFailed: "Failed to load file ({{status}})",
    networkError: "Cannot connect to server. Check your internet connection.",
    invalidResponse: "Invalid response format",
    requestFailedStatus: "Request failed ({{status}})",
    requestFailed: "Request failed",
  },
  editPage: {
    conflictChoice:
      "OK = overwrite their changes with yours\nCancel = keep your edits (reload the page to see the latest first).",
  },
  errorBoundary: {
    unexpected: "An unexpected error occurred.",
    reload: "Reload page",
  },
  editPageHeader: {
    createNew: "Create a new {{name}}",
    editing: "Editing: {{name}}",
    view: "View",
  },
  validationBanner: {
    title: "The form cannot be saved — please fix these fields:",
  },
  listSort: {
    recent: "Recently updated",
    titleAsc: "Name A–Z",
    orderAsc: "By sort order",
    priceAsc: "Price low to high",
    withoutDestination: "No destination",
  },
  facetedList: {
    searchPlaceholder: "Search…",
    filters: "Filters",
    clearCount: "Clear ({{count}})",
    showAll: "Show all ({{count}})",
    showLess: "Show less",
    showingRange: "Showing {{from}}–{{to}} of {{total}}",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark all read",
    empty: "No notifications",
    justNow: "now",
    minutesShort: "{{count}}m",
    hoursShort: "{{count}}h",
    daysShort: "{{count}}d",
  },
  aiReview: {
    title: "AI assist",
    subtitle: "Paste an email / message to pre-fill the lead",
    inputPlaceholder: "Paste the customer's inquiry here…",
    parseButton: "Parse with AI",
    parseFailed: "Could not parse — try again or fill manually.",
    score: "Score {{score}}",
    avgConfidence: "{{percent}}% avg confidence",
    returningCustomer: "Returning customer:",
    existingLead: "Existing open lead {{leadNumber}} ({{status}})",
    suggestedReply: "Suggested reply",
    applyToForm: "Apply to form",
    fields: {
      adults: "Adults",
      children: "Children",
      summary: "Summary",
    },
  },
  faqEditor: {
    empty: "No FAQ categories yet. Add a category or pre-fill defaults.",
    expand: "Expand",
    collapse: "Collapse",
    topicPlaceholder: 'e.g. "General", "Useful tips", "Booking"',
    defaultTopic: "General",
    moveCategoryUp: "Move category up",
    moveCategoryDown: "Move category down",
    deleteCategory: "Delete category",
    moveTo: "Move to…",
    categoryN: "Category {{number}}",
    question: "Question",
    questionPlaceholder: "e.g. What size are your groups?",
    answer: "Answer",
    answerPlaceholder: "Answer to the question…",
    addQuestion: "+ Add question",
    addCategory: "+ Add category",
    prefillDefaults: "Pre-fill defaults",
  },
  headingHero: {
    title: "Heading & Hero",
    heroTitle: "Hero title",
    heroPlaceholder: "e.g. Vietnam Adventure",
    heroHint: "Short text displayed on hero image (2–5 words). If empty, uses {{fallback}}.",
    heading: "Page heading (H1)",
    headingPlaceholder: "e.g. Explore the beauty of Vietnam from North to South",
    headingHint:
      "Main heading below the hero section. Can be longer and more descriptive. If empty, uses {{fallback}}.",
    fallbackTitle: "Title",
  },
  mediaPicker: {
    dragToReorder: "Drag to reorder",
    selectOrUpload: "Select or upload",
    change: "Change",
    doneBackToLibrary: "Done — back to library",
  },
  orderItems: {
    unitPrice: "Unit price",
    qty: "Qty",
    lineTotal: "Line total",
    empty: "No line items yet",
    itemNamePlaceholder: "Item name",
    priceOverride: "Price override — catalog trip unchanged",
    addLine: "Add line",
    addAddon: "Add-on",
    addDiscount: "Discount",
  },
  readiness: {
    title: "Readiness",
    readyCount: "{{done}}/{{total}} ready",
    markDone: "Mark done",
    markNotDone: "Mark not done",
    done: "Done",
    addPlaceholder: "e.g. Collect dietary preferences",
    addItem: "Add checklist item",
  },
  recentCalls: {
    title: "Recent calls",
    showTranscript: "Show transcript",
    hideTranscript: "Hide transcript",
    followUpScheduled: "Follow-up scheduled",
    followUpFailed: "Failed to apply follow-up",
    proposedFollowUp: "Proposed follow-up {{date}}",
    scheduled: "Scheduled",
  },
  relatedItems: {
    defaultLabel: "Related items",
    searchPlaceholder: "Search items…",
    selectedCount: "Selected ({{count}})",
    noMatches: "No matching items",
    noItems: "No items available",
  },
  destinationPicker: {
    searchPlaceholder: "Search destination…",
    none: "No destination",
    draft: "draft",
    loading: "Loading destinations…",
    noMatches: "Nothing found",
    loadError: "Destinations could not be loaded.",
    retry: "Try again",
    removeTag: "Remove tag",
  },
  roomTypes: {
    title: "Room types",
    hint: "Per-room buy cost for each offered room type. Used for accommodation priced by room — a booking picks one type and snapshots its cost; the calculator splits it across occupancy (single → no roommate, the supplement falls out). Leave empty to use the flat cost above.",
    costPerRoom: "Cost / room",
    removeTitle: "Remove room type",
    add: "Add room type",
  },
  paxGrid: {
    show: "Pax grid",
    hide: "Hide pax grid",
    empty: "No travellers yet — add participants to the order first.",
    traveller: "Traveller",
    paid: "Paid",
    issued: "Issued",
    toGuide: "To guide",
    checked: "Checked",
  },
  serviceBookings: {
    title: "Services",
    addService: "Add service",
    editService: "Edit service",
    newService: "New service",
    saveService: "Save service",
    deviation: "deviation",
    payBy: "pay by {{date}}",
    perPaxSuffix: "/pax",
    perRoomSuffix: "/room",
    fromCatalog: "From catalog",
    manualEntry: "— manual entry —",
    namePlaceholder: "e.g. Sofitel Metropole — 2 nights",
    kind: "Kind",
    roomType: "Room type",
    flatCost: "— flat cost —",
    allotmentLabel_one: "Group allotment (draws {{count}} seat from the block)",
    allotmentLabel_few: "Group allotment (draws {{count}} seats from the block)",
    allotmentLabel_other: "Group allotment (draws {{count}} seats from the block)",
    noBlock: "— FIT / no block —",
    supplier: "Supplier",
    none: "— none —",
    matching: "Matching",
    otherSuppliers: "Other suppliers",
    cost: "Cost",
    scope: "Scope",
    pax: "Pax",
    confirmBy: "Confirm by",
    paxCountBy: "Pax count by",
    payByLabel: "Pay by",
    notesLabel: "Notes / details",
    notesPlaceholder: "PNR, room list, policy numbers…",
    customizationLabel: "Customization note (deviation from standard — shown to the guide)",
    customizationPlaceholder: "e.g. Upgraded to 5★ (was 3★ standard) — leave empty if standard",
    supplierEmail: "Supplier email",
    generateDraft: "Generate draft",
    linkSupplierFirst: "Link a supplier with an email first",
    noEmailOnFile: "{{name}} has no email on file — add one in Suppliers.",
    thisSupplier: "This supplier",
    linkSupplierHint: "Link a supplier with an email above to draft a message.",
    emailTo: "To: {{to}}",
    sent: "Sent ✓",
    sendViaGmail: "Send via Gmail",
    confirmations: "Supplier confirmations",
    attachPdf: "Attach PDF",
    aiFill: "AI fill",
    confirmationsHint: "Hotel voucher / booking confirmation — flows to the guide PWA offline.",
    aiFillHint: "reads the PDF and prefills the details below — review & Save.",
    parseTitle: "Parse a confirmation",
    parsePlaceholder: "Paste a flight ticket / insurance / hotel confirmation here…",
    extractDetails: "Extract details",
    nothingExtracted: "Nothing extracted.",
    addToNotes: "Add to notes",
    empty: "No services yet. Add hotels, flights, insurance…",
    supplierGroups: {
      airline: "Airlines",
      hotel: "Hotels",
      insurance: "Insurers",
      transport: "Transport",
      guide: "Guides",
      activity: "Activities",
      visa: "Visa agents",
      other: "Other",
    },
  },
  videoLink: {
    invalid:
      "The website will not show this link. Supported are YouTube and Instagram video links.",
  },
  socialReels: {
    empty: "No social reels yet. The section is hidden on the website.",
    reelN: "Reel {{number}}",
    titlePlaceholder: "Reel title…",
    linkLabel: "Link (optional)",
    thumbnail: "Thumbnail",
    addReel: "+ Add reel",
    inheritedLine_one:
      "On the website, these videos are followed by the video of {{country}} ({{count}}): {{titles}}",
    inheritedLine_few:
      "On the website, these videos are followed by the videos of {{country}} ({{count}}): {{titles}}",
    inheritedLine_other:
      "On the website, these videos are followed by the videos of {{country}} ({{count}}): {{titles}}",
    noLinkWarning: "Without a link it will not show on the website",
  },
  agent: {
    briefLabel: "Brief me",
    briefHeading: "AI brief",
    handoverLabel: "Handover note",
    handoverHeading: "Handover note",
    generateFailed: "Couldn't generate the summary.",
    entityOrder: "Order #{{id}}",
    entityLead: "Inquiry {{id}}",
    entityCustomer: "Customer {{id}}",
    entityDeparture: "Departure {{id}}",
    ask1: "Is guide Martin free for a trip 22–29 Sep?",
    ask2: "How many people are booked on the cooking class next week?",
    ask3: "On this trip, how many travellers have our insurance vs their own?",
    ask4: "Which flights still need confirming before their deadline?",
    ask5: "What's the margin on this order?",
    do1: "Duplicate this order, drop the cruise and take 2,000 CZK off.",
    do2: "Move this booking to the next departure and email the hotel to rebook.",
    do3: "Draft a deposit reminder for this customer.",
    do4: "Find a replacement guide for this departure and assign them.",
    attachFailed: "Couldn't attach the file",
    chatFailed: "The assistant hit an error.",
    openAssistant: "Open MAKEJ! assistant",
    waitingApproval: "Waiting for your approval ({{count}})",
    intro: "I read everything in the CRM and prepare changes for you to approve.",
    lookingAt: "Looking at",
    askHeading: "Ask me things like",
    doHeading: "…or have me prepare a change",
    noReply: "(no reply)",
    working: "Working…",
    uploading: "Uploading…",
    removeAttachment: "Remove attachment",
    attachTitle: "Attach a photo, PDF or CSV/text file",
    inputPlaceholder: "Message MAKEJ!…",
    approveAll: "Approve all",
    approvePlanFailed: "Couldn't approve the plan",
    heldNotice_one:
      "Internal steps applied. {{count}} outgoing/money step still needs your confirmation below.",
    heldNotice_few:
      "Internal steps applied. {{count}} outgoing/money steps still need your confirmation below.",
    heldNotice_other:
      "Internal steps applied. {{count}} outgoing/money steps still need your confirmation below.",
    tierRead: "read",
    tierWrite: "write",
    tierMoney: "money",
    executionFailed: "Execution failed",
    approveFailed: "Failed to approve",
    rejectFailed: "Failed to reject",
    loadDraftFailed: "Couldn't load the draft",
    saveEditFailed: "Couldn't save the edit",
    revertFailed: "Failed to revert",
    revertNote: "{{restored}} restored, {{skipped}} skipped (changed since): {{fields}}",
    subjectPlaceholder: "Subject",
    bodyPlaceholder: "Email body",
    saveText: "Save text",
    approvedExecuted: "Approved & executed",
    reverted: "Reverted",
    revert: "Revert",
    dismissed: "Dismissed",
    confirmTier: "Confirm this {{tier}} action?",
    yesConfirm: "Yes, confirm",
    approve: "Approve",
    dismiss: "Dismiss",
    awaitingOperator: "Awaiting approval from an operator.",
  },
};
